import { createSvgIcon } from '@mui/material';

export const HK = createSvgIcon(
  <svg
    id='Layer_1'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 76 76'
  >
    <defs>
      <linearGradient
        id='linear-gradient'
        x1='9.38'
        y1='60.72'
        x2='60.15'
        y2='15.49'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-2'
        x1='12.03'
        y1='63.69'
        x2='62.8'
        y2='18.45'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-3'
        x1='50.07'
        y1='36.71'
        x2='66.19'
        y2='22.35'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-4'
        x1='32.1'
        y1='38.23'
        x2='32.1'
        y2='29.37'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#fcba73' />
        <stop offset='1' stopColor='#c86904' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-5'
        x1='32.1'
        y1='49.31'
        x2='32.1'
        y2='40.45'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#fcba73' />
        <stop offset='1' stopColor='#c86904' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-6'
        x1='44.4'
        y1='49.31'
        x2='44.4'
        y2='40.45'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#fcba73' />
        <stop offset='1' stopColor='#c86904' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-7'
        x1='46.57'
        y1='36.52'
        x2='60.57'
        y2='13.29'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#fcba73' />
        <stop offset='1' stopColor='#c86904' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-8'
        x1='12.05'
        y1='22.78'
        x2='25.71'
        y2='9.12'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#414cc8' />
        <stop offset='1' stopColor='#2b3493' />
      </linearGradient>
    </defs>
    <g>
      <path
        d='M60.93,37.7c1.5,0,2.83-1.24,2.83-2.83.09-.79-.26-1.5-.97-2.12l-22.55-19.82c-.53-.44-1.24-.62-1.85-.62s-1.32.09-1.94.71l-22.63,19.73c-.32.32-.55.66-.69,1.03-.13.34-.19.7-.19,1.09,0,1.6,1.24,2.83,2.83,2.83h2.83v6.15c0,.08,0,.17,0,.25v9.89c0,1.95,1.58,3.53,3.53,3.53h1.41s.08,0,.12,0c.04,0,.08,0,.12,0h.08c.13,0,.26.01.4.01h5s.02,0,.02,0h12.3c-.21-.8-.32-1.62-.32-2.47v-.99c0-1.61.64-3.15,1.77-4.28,1.05-1.05,2.44-1.67,3.91-1.76-.79-1.32-1.21-2.83-1.21-4.39,0-2.27.9-4.44,2.5-6.04,1.6-1.6,3.78-2.5,6.04-2.5s4.44.9,6.04,2.5c.04.04.08.08.12.12h.52Z'
        fill='url(#linear-gradient)'
        strokeWidth='0'
      />
      <path
        d='M50.38,47.49c.09.09.18.17.27.26.1.09.21.18.32.26-.21-.16-.41-.33-.59-.51Z'
        fill='url(#linear-gradient-2)'
        strokeWidth='0'
      />
      <path
        d='M58.11,47.49s.02-.03.04-.04l-.04.04Z'
        fill='url(#linear-gradient-3)'
        strokeWidth='0'
      />
    </g>
    <path
      d='M27.38,38.95c0-.61.49-1.1,1.1-1.1h7.43c.61,0,1.1.49,1.1,1.1v7.16c0,.61-.49,1.1-1.1,1.1h-7.43c-.61,0-1.1-.49-1.1-1.1v-7.16Z'
      fill='#2962ff'
      strokeWidth='0'
    />
    <path
      d='M27.38,27.87c0-.61.49-1.1,1.1-1.1h7.43c.61,0,1.1.49,1.1,1.1v7.16c0,.61-.49,1.1-1.1,1.1h-7.43c-.61,0-1.1-.49-1.1-1.1v-7.16Z'
      fill='#2962ff'
      strokeWidth='0'
    />
    <path
      d='M39.48,27.87c0-.61.49-1.1,1.1-1.1h7.43c.61,0,1.1.49,1.1,1.1v7.16c0,.61-.49,1.1-1.1,1.1h-7.43c-.61,0-1.1-.49-1.1-1.1v-7.16Z'
      fill='#2962ff'
      strokeWidth='0'
    />
    <path
      d='M27.38,38.02c0-.61.49-1.1,1.1-1.1h7.43c.61,0,1.1.49,1.1,1.1v7.16c0,.61-.49,1.1-1.1,1.1h-7.43c-.61,0-1.1-.49-1.1-1.1v-7.16Z'
      fill='#fff'
      strokeWidth='0'
    />
    <path
      d='M27.38,26.95c0-.61.49-1.1,1.1-1.1h7.43c.61,0,1.1.49,1.1,1.1v7.16c0,.61-.49,1.1-1.1,1.1h-7.43c-.61,0-1.1-.49-1.1-1.1v-7.16Z'
      fill='#fff'
      strokeWidth='0'
    />
    <path
      d='M39.48,26.95c0-.61.49-1.1,1.1-1.1h7.43c.61,0,1.1.49,1.1,1.1v7.16c0,.61-.49,1.1-1.1,1.1h-7.43c-.61,0-1.1-.49-1.1-1.1v-7.16Z'
      fill='#fff'
      strokeWidth='0'
    />
    <path
      d='M35.52,39.41c.36.36.36.94,0,1.31l-3.69,3.69c-.36.36-.94.36-1.31,0l-1.85-1.85c-.36-.36-.36-.94,0-1.31.36-.36.94-.36,1.31,0l1.19,1.19,3.04-3.04c.36-.36.94-.36,1.31,0Z'
      fill='#c86904'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M35.52,39.04c.36.36.36.94,0,1.31l-3.69,3.69c-.36.36-.94.36-1.31,0l-1.85-1.85c-.36-.36-.36-.95,0-1.31.36-.36.94-.36,1.31,0l1.19,1.19,3.04-3.04c.36-.36.94-.36,1.31,0Z'
      fill='url(#linear-gradient-4)'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M35.52,28.33c.36.36.36.94,0,1.31l-3.69,3.69c-.36.36-.94.36-1.31,0l-1.85-1.85c-.36-.36-.36-.94,0-1.31.36-.36.94-.36,1.31,0l1.19,1.19,3.04-3.04c.36-.36.94-.36,1.31,0Z'
      fill='#c86904'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M35.52,27.96c.36.36.36.94,0,1.31l-3.69,3.69c-.36.36-.94.36-1.31,0l-1.85-1.85c-.36-.36-.36-.94,0-1.31.36-.36.94-.36,1.31,0l1.19,1.19,3.04-3.04c.36-.36.94-.36,1.31,0Z'
      fill='url(#linear-gradient-5)'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M47.83,28.33c.36.36.36.94,0,1.31l-3.69,3.69c-.36.36-.94.36-1.31,0l-1.85-1.85c-.36-.36-.36-.94,0-1.31.36-.36.94-.36,1.31,0l1.19,1.19,3.04-3.04c.36-.36.94-.36,1.31,0Z'
      fill='#c86904'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M47.83,27.96c.36.36.36.94,0,1.31l-3.69,3.69c-.36.36-.94.36-1.31,0l-1.85-1.85c-.36-.36-.36-.94,0-1.31.36-.36.94-.36,1.31,0l1.19,1.19,3.04-3.04c.36-.36.94-.36,1.31,0Z'
      fill='url(#linear-gradient-6)'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M61.21,52c.79,0,1.55.31,2.11.87.56.56.87,1.32.87,2.11v.99c0,3.92-3.7,7.95-9.94,7.95s-9.94-4.03-9.94-7.95v-.99c0-.79.31-1.55.87-2.11.56-.56,1.32-.87,2.11-.87h13.92ZM54.25,39.08c1.45,0,2.84.58,3.87,1.6,1.03,1.03,1.6,2.42,1.6,3.87s-.58,2.84-1.6,3.87c-1.03,1.03-2.42,1.6-3.87,1.6s-2.84-.58-3.87-1.6c-1.03-1.03-1.6-2.42-1.6-3.87s.58-2.84,1.6-3.87c1.03-1.03,2.42-1.6,3.87-1.6Z'
      fill='#c86904'
      strokeWidth='0'
    />
    <path
      d='M61.21,51.08c.79,0,1.55.31,2.11.87.56.56.87,1.32.87,2.11v.99c0,3.92-3.7,7.95-9.94,7.95s-9.94-4.03-9.94-7.95v-.99c0-.79.31-1.55.87-2.11.56-.56,1.32-.87,2.11-.87h13.92ZM54.25,38.15c1.45,0,2.84.58,3.87,1.6,1.03,1.03,1.6,2.42,1.6,3.87s-.58,2.84-1.6,3.87c-1.03,1.03-2.42,1.6-3.87,1.6s-2.84-.58-3.87-1.6c-1.03-1.03-1.6-2.42-1.6-3.87s.58-2.84,1.6-3.87c1.03-1.03,2.42-1.6,3.87-1.6Z'
      fill='url(#linear-gradient-7)'
      strokeWidth='0'
    />
    <path
      d='M9.4,55.88c1.27-4.54,5.44-7.88,10.4-7.88s8.89,3.15,10.28,7.51h1.71c4.7,0,8.51,3.81,8.51,8.51s-3.81,8.51-8.51,8.51H11.9c-4.7,0-8.51-3.81-8.51-8.51,0-3.83,2.53-7.08,6.02-8.14Z'
      fill='url(#linear-gradient-8)'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M6.96,53.53c2.07-5.05,7.04-8.61,12.84-8.61,5.37,0,10.02,3.05,12.33,7.51,6.25.18,11.26,5.29,11.26,11.58s-5.19,11.59-11.59,11.59H11.9c-6.4,0-11.59-5.19-11.59-11.59,0-4.64,2.72-8.64,6.66-10.49ZM9.4,55.88c1.27-4.54,5.44-7.88,10.4-7.88s8.89,3.15,10.28,7.51h1.71c4.7,0,8.51,3.81,8.51,8.51s-3.81,8.51-8.51,8.51H11.9c-4.7,0-8.51-3.81-8.51-8.51,0-3.83,2.53-7.08,6.02-8.14Z'
      fill='#fff'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M19.6,60h1.74v7.54h-1.74v-7.54ZM16.18,67.54h-1.74v-7.54h1.74v7.54ZM19.73,64.45h-3.68v-1.48h3.68v1.48ZM24.69,65.82l-.1-2.01,3.61-3.8h1.94l-3.25,3.5-.97,1.03-1.23,1.28ZM23.13,67.54v-7.54h1.73v7.54h-1.73ZM28.29,67.54l-2.68-3.28,1.14-1.24,3.58,4.52h-2.04Z'
      fill='#252c7e'
      strokeWidth='0'
    />
    <path
      d='M19.6,59.38h1.74v7.54h-1.74v-7.54ZM16.18,66.92h-1.74v-7.54h1.74v7.54ZM19.73,63.83h-3.68v-1.48h3.68v1.48ZM24.69,65.2l-.1-2.01,3.61-3.8h1.94l-3.25,3.5-.97,1.03-1.23,1.28ZM23.13,66.92v-7.54h1.73v7.54h-1.73ZM28.29,66.92l-2.68-3.28,1.14-1.24,3.58,4.52h-2.04Z'
      fill='#fff'
      strokeWidth='0'
    />
  </svg>,
  'HK',
);
